export default __webpack_public_path__ + "locales/lv/DeleteThirdPartyDialog.json?hash=6cdca76828d3a84c7b0ef66320525f32";